import { makeStyles } from '@material-ui/core/styles';
import { THEME } from 'GlobalStyles';
import { container } from 'UI/constants/dimensions';
import { getHeaderBandBackground } from 'UI/theme/darkTones';
import { flexAlignCenterJustifyCenter } from 'UI/utils/styles';

export const cardStyles = {
  root: {
    boxShadow: container.boxShadow,
    position: 'relative',
    zIndex: 0,
    borderRadius: 12
  }
};

export const useHeaderStyles = makeStyles(
  theme => ({
    defaultBackground: {
      backgroundColor: getHeaderBandBackground(theme)
    },
    headerPadding: {
      padding: theme.spacing(2)
    },
    regularHeaderTitle: { fontSize: 20 },
    subHeaderColor: {
      color: THEME.palette.status.inactive
    },
    subHeadHeroPadding: {
      paddingTop: theme.spacing(0.5)
    }
  }),
  { name: 'MuiCardHeader' }
);

export const useActionStyles = makeStyles({
  actionAndExpandContainer: {
    alignItems: 'center'
  }
});

export const useContentStyles = makeStyles(
  theme => ({
    tight: {
      padding: 0,
      '&:last-child': {
        paddingBottom: 0
      }
    },
    regular: {
      padding: theme.spacing(2)
    },
    relaxed: {
      padding: theme.spacing(3)
    }
  }),
  { name: 'MuiCardContent' }
);

export const useFooterStyles = makeStyles(theme => ({
  buttonContainer: {
    margin: theme.spacing(2, 0, 0),
    ...flexAlignCenterJustifyCenter
  }
}));
